import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = ({ onWhatsAppClick, onConsultationClick }) => {
  return (
    <section className="relative bg-gradient-forest text-white overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="font-playfair text-4xl lg:text-6xl font-bold leading-tight">
                Transforme Sua Visão em
                <span className="block text-accent"> Realidade Artesanal</span>
              </h1>
              <p className="text-xl text-white/90 leading-relaxed">
                Conecte-se conosco para uma consultoria personalizada e descubra como criar móveis únicos que refletem sua personalidade e estilo de vida.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="MessageCircle"
                iconPosition="left"
                onClick={onWhatsAppClick}
                className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-premium"
              >
                WhatsApp Direto
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                onClick={onConsultationClick}
                className="border-white text-white hover:bg-white hover:text-primary"
              >
                Agendar Consultoria
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/20">
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Icon name="Clock" size={24} color="var(--color-accent)" />
                </div>
                <p className="text-sm text-white/80">Resposta em</p>
                <p className="font-semibold">15 minutos</p>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Icon name="Users" size={24} color="var(--color-accent)" />
                </div>
                <p className="text-sm text-white/80">Consultoria</p>
                <p className="font-semibold">Gratuita</p>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Icon name="Award" size={24} color="var(--color-accent)" />
                </div>
                <p className="text-sm text-white/80">Experiência</p>
                <p className="font-semibold">15+ anos</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="space-y-6">
                <div className="text-center">
                  <Icon name="Sparkles" size={32} color="var(--color-accent)" className="mx-auto mb-4" />
                  <h3 className="font-playfair text-2xl font-semibold mb-2">Consultoria Especializada</h3>
                  <p className="text-white/80">
                    Nossa equipe de designers e artesãos está pronta para transformar suas ideias em móveis únicos
                  </p>
                </div>

                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <Icon name="CheckCircle" size={20} color="var(--color-accent)" />
                    <span className="text-sm">Análise gratuita do seu espaço</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="CheckCircle" size={20} color="var(--color-accent)" />
                    <span className="text-sm">Sugestões personalizadas de design</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="CheckCircle" size={20} color="var(--color-accent)" />
                    <span className="text-sm">Orçamento detalhado sem compromisso</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="CheckCircle" size={20} color="var(--color-accent)" />
                    <span className="text-sm">Acompanhamento completo do projeto</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;